import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "step-by-step-discussion"
    }}>{`Step By Step Discussion`}</h1>
    <p>{`Please follow the article `}<a parentName="p" {...{
        "href": "https://redq.io/blog/woocommerce-booking-plugin/"
      }}>{`https://redq.io/blog/woocommerce-booking-plugin/`}</a>{` for step by step discussion of the settings of our plugin.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      